import script from "./CmakerRunsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CmakerRunsPage.vue?vue&type=script&setup=true&lang=js"

import "./CmakerRunsPage.vue?vue&type=style&index=0&id=bfac08b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfac08b2"]])

export default __exports__